import { Controller } from "@hotwired/stimulus";

// Coche ou décoche d'un coup toutes les cases d'un bloc (grille des marques d'un tuto).
export default class extends Controller {
  static targets = ["box"];

  toggleAll(event) {
    event.preventDefault();
    const shouldCheck = this.boxTargets.some((box) => !box.checked);
    this.boxTargets.forEach((box) => {
      box.checked = shouldCheck;
    });
  }
}
